"use strict";

module.exports = require("./ProviderView.js");